/**
 * NOTE: Policy templates are currently stored in code as a temporary solution.
 * These templates will be moved to a separate storage location to maintain
 * synchronization with the frontend implementation.
 * TODO: Move policy templates to a centralized storage solution
 */

import {
    PolicyId,
    Template
} from "@cedar-policy/cedar-wasm/nodejs";

import { PolicyTemplateStore } from "./PolicyTemplateStore";

const POLICY_TEMPLATES: Record<PolicyId, Template> = {
    "viewer-template": `permit (
        principal in ?principal,
        action in Action::"VIEWER_ACTION_GROUP",
        resource in ?resource
    );`,
    "editor-template": `permit (
        principal in ?principal,
        action in Action::"EDITOR_ACTION_GROUP",
        resource in ?resource
    );`,
    "admin-template": `permit (
        principal in ?principal,
        action in Action::"ADMIN_ACTION_GROUP",
        resource in ?resource
    );`
};

export class DefaultPolicyTemplateStore implements PolicyTemplateStore {
    public async listAll(): Promise<Record<PolicyId, Template>> {
        return POLICY_TEMPLATES;
    }
}

export const defaultPolicyTemplateStore = new DefaultPolicyTemplateStore();